const blogListConstantsAr = {
  blogListTitle:'المدونات',
  arabicTitle: 'العنوان بالعربية',
  englishTitle: 'العنوان بالإنجليزية',
  publishDate: 'تاريخ النشر',
  blogStatus: 'الحالة',
  totalBlogs: 'مدونة',
  deleteBlogTitle: 'حذف المدونة',
  deleteBlogContent: 'هل أنت متأكد أنك تريد حذف هذه المدونة من لوحة الإدارة ؟',
};
export default blogListConstantsAr;
